import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import useAxios from 'axios-hooks';
import isEmpty from 'lodash.isempty';
import uniqueId from 'lodash.uniqueid';

import { Button, TabPanel } from '../../../components';
import QuestionnaireTab from './components/QuestionnaireTab';

const QuestionnaireResultsModal = ({ providerId, isOpen, onClose, campaign_sent_id, campaignPatient }) => {
	const [{ data, loading /*, error */ }, loadSentDetail] = useAxios({
		url: `/providers/${providerId}/campaign-sent-detail`,
		method: 'GET',
	}, { manual: true });
	const [{ data: groupsData, /* loading: loadingGroups, error */ }, loadGroups] = useAxios({
		url: '/care_quest_groups',
		method: 'GET',
	}, { manual: true });

	useEffect(() => {
		if (isOpen) {
			loadSentDetail({
				params: {
					campaign_sent_id
				}
			});
		}
	}, [isOpen, campaign_sent_id, campaignPatient]);

	useEffect(() => {
		if (Array.isArray(data) && data.length > 0) {
			loadGroups({
				params: {
					filter: JSON.stringify({
						where: {
							id: {
								inq: data.map(({ care_quest_group_id }) => care_quest_group_id)
							}
						}
					})
				}
			});
		}
	}, [data]);

	const handlePrintClicked = () => {
		window.print();
	};

	if (Array.isArray(data) && Array.isArray(groupsData)) {
		data.forEach((dataRow) => {
			dataRow.group = groupsData.find((groupsDataRow) => groupsDataRow.id === dataRow.care_quest_group_id) || {};
		});
	}

	return (
		<Modal isOpen={isOpen} contentLabel="Questionnaire Results" className="modal-dialog questionnaire-results-modal modal-lg">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={handlePrintClicked}>
								<em className="fa fa-print"></em>
							</button>
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							Questionnaire Results
						</h3>
					</div>
				</div>
				<div className="modal-body">
					{loading && (
						<div>Loading results...</div>
					)}
					{!loading && Array.isArray(data) && Array.isArray(groupsData) && (
						<>
							{campaignPatient && !isEmpty(campaignPatient.first_name) && (
								<div>
									<p>
										<strong>{campaignPatient.first_name} {campaignPatient.middle_name} {campaignPatient.last_name}</strong><br />
										{campaignPatient.address1}<br />
										{!isEmpty(campaignPatient.address2) && (
											<>
												{campaignPatient.address2}<br />
											</>
										)}
										{campaignPatient.city}, {campaignPatient.state} {campaignPatient.zip}
									</p>
								</div>
							)}
							<TabPanel>
								{data.map((respDetail) => (
									<QuestionnaireTab
										{...respDetail}
										providerId={providerId}
										key={`care_quest_response_groupId-${respDetail.care_quest_response_groupId || uniqueId('incomplete-')}`}
										id={`care_quest_response_groupId-${respDetail.care_quest_response_groupId || uniqueId('incomplete-')}`}
										title={respDetail.group.name}
									/>
								))}
							</TabPanel>
						</>
					)}
				</div>
				<div className="modal-footer">
					<div className="pull-right">
						<Button
							title="OK"
							onClick={onClose}
							large
							primary
							className="ml"
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

QuestionnaireResultsModal.propTypes = {
	providerId: PropTypes.number,
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	campaign_sent_id: PropTypes.number,
	campaignPatient: PropTypes.object,
};

export default QuestionnaireResultsModal;
